/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import type { AdvisorStats } from './advisor-stats';
// May contain unused imports in some cases
// @ts-ignore
import type { DatabaseInstanceConfig } from './database-instance-config';

/**
 * Cache group with combined query and index recommendation statistics
 * @export
 * @interface AdvisorCacheGroup
 */
export interface AdvisorCacheGroup {
    /**
     * Config details collected by the DB agent
     * @type {DatabaseInstanceConfig}
     * @memberof AdvisorCacheGroup
     */
    'config': DatabaseInstanceConfig;
    /**
     * Total number of databases in this cache group
     * @type {number}
     * @memberof AdvisorCacheGroup
     */
    'databaseCount': number;
    /**
     * Operational status of the DB agent for this cache group
     * @type {string}
     * @memberof AdvisorCacheGroup
     */
    'dbAgentStatus': AdvisorCacheGroupDbAgentStatusEnum;
    /**
     * Unique identifier for the cache group
     * @type {string}
     * @memberof AdvisorCacheGroup
     */
    'id': string;
    /**
     * Name of the cache group
     * @type {string}
     * @memberof AdvisorCacheGroup
     */
    'name': string;
    /**
     * Database protocol type
     * @type {string}
     * @memberof AdvisorCacheGroup
     */
    'protocol': AdvisorCacheGroupProtocolEnum;
    /**
     * Combined query and index recommendation statistics
     * @type {AdvisorStats}
     * @memberof AdvisorCacheGroup
     */
    'stats': AdvisorStats;
}

export const AdvisorCacheGroupDbAgentStatusEnum = {
    DB_AGENT_STATUS_UNSPECIFIED: 'DB_AGENT_STATUS_UNSPECIFIED',
    COLLECTING: 'COLLECTING',
    ERROR: 'ERROR',
    NOT_INSTALLED: 'NOT_INSTALLED'
} as const;

export type AdvisorCacheGroupDbAgentStatusEnum = typeof AdvisorCacheGroupDbAgentStatusEnum[keyof typeof AdvisorCacheGroupDbAgentStatusEnum];
export const AdvisorCacheGroupProtocolEnum = {
    PROTOCOL_TYPE_UNSPECIFIED: 'PROTOCOL_TYPE_UNSPECIFIED',
    POSTGRESQL: 'POSTGRESQL',
    MYSQL: 'MYSQL'
} as const;

export type AdvisorCacheGroupProtocolEnum = typeof AdvisorCacheGroupProtocolEnum[keyof typeof AdvisorCacheGroupProtocolEnum];


